import moment from "moment"
import {DateTime} from '@/constants/DoITConstant.js'

export const timeDifferent = (time) => {
  const formatUploadTime = (uploadTime) => {
    return moment(uploadTime).format("HH:mm DD/MM/YY")
  }

  let current = new Date()
  let pastTime = new Date(time)
  let year = Math.floor(current.getFullYear() - pastTime.getFullYear())
  if (year >= 1) return formatUploadTime(time)
  let month = Math.floor(current.getMonth() - pastTime.getMonth())
  if (month >= 1) return formatUploadTime(time)
  let days = Math.floor(current.getDate() - pastTime.getDate())
  if (days > 3) return formatUploadTime(time)
  if (days >= 1 && days <= 3) return days + " ngày trước"
  let hours = Math.floor(current.getHours() - pastTime.getHours())
  if (hours >= 1) return hours + " giờ trước"
  let munites = Math.floor(current.getMinutes() - pastTime.getMinutes())
  if (munites >= 1) return munites + " phút trước"
  return "vài giây trước"
}

export const formatDateTime = (time) => {
  return time ? moment(time).format(DateTime.DATE_TIME_FORMAT) : ""
}

export const formatDate = (time) => {
  return time ? moment(time).format(DateTime.DATE_FORMAT) : ""
}

export const formatDayMonth = (time) => {
  return time ? moment(time).format(DateTime.DAY_MONTH_FORMAT) : ""
}

